import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useAuthContext } from './components/AuthProvider';
import './ReferralLandingPage.css';

export default function ReferralLandingPage() {
  const { code } = useParams();
  const navigate = useNavigate();
  const { user, loading, signInWithGoogle } = useAuthContext();

  // Store the referral code in localStorage so it gets auto-applied after sign-in
  useEffect(() => {
    if (code) {
      localStorage.setItem('latted_referral_code', code.trim().toUpperCase());
    }
  }, [code]);

  // If already signed in, redirect to the activate page
  useEffect(() => {
    if (!loading && user) {
      navigate('/referral/activate', { replace: true });
    }
  }, [user, loading, navigate]);

  return (
    <div className="referral-landing">
      <div className="referral-landing-card">
        <div className="referral-landing-badge">INVITE</div>

        <h1 className="referral-landing-title">
          You've been invited to <span className="referral-landing-brand">Latted</span>
        </h1>

        <p className="referral-landing-subtitle">
          Sign up now and you'll both get <strong>$10 in free credits</strong> when you make your first $10+ purchase.
        </p>

        <div className="referral-landing-steps">
          <div className="referral-landing-step">
            <span className="referral-landing-step-number">1</span>
            <div>
              <strong>Create your account</strong>
              <span>Sign up with Google</span>
            </div>
          </div>
          <div className="referral-landing-step">
            <span className="referral-landing-step-number">2</span>
            <div>
              <strong>Buy $10+ in credits</strong>
              <span>Use credits to generate AI videos</span>
            </div>
          </div>
          <div className="referral-landing-step">
            <span className="referral-landing-step-number">3</span>
            <div>
              <strong>Get $10 bonus</strong>
              <span>Both you and your friend earn $10</span>
            </div>
          </div>
        </div>

        <button
          type="button"
          className="referral-landing-google"
          onClick={signInWithGoogle}
        >
          <img src="/google.svg" alt="Google" />
          <span>Continue with Google</span>
        </button>

        <footer className="referral-landing-footer">
          <p>
            By continuing you agree to our{' '}
            <a href="/terms" target="_blank" rel="noreferrer">Terms of Service</a>{' '}
            and{' '}
            <a href="/privacy" target="_blank" rel="noreferrer">Privacy Policy</a>.
          </p>
        </footer>
      </div>
    </div>
  );
}
